import Loading from 'components/Loading';
import Subheader from 'components/Subheader';
import BrowserContainer from 'containers/BrowserContainer';
import ContentContainer from 'containers/ContentContainer';
import CookieConsentContainer from 'containers/CookieConsentContainer';
import ErrorContainer from 'containers/ErrorContainer';
import FooterContainer from 'containers/FooterContainer';
import GlobalTrackingContainer from 'containers/GlobalTrackingContainer';
import HeaderContainer from 'containers/HeaderContainer';
import SidebarContainer from 'containers/SidebarContainer';
import ViewContainer from 'containers/ViewContainer/ViewContainer';
import ToggleBox from 'develop/ToggleBox';
import { AnimationProvider } from 'providers/Animation';
import DocumentHead from 'providers/DocumentHead';
import KameleoonProvider from 'providers/Kameleoon';
import LanguageProvider from 'providers/Language';
import PageTitle from 'providers/PageTitle';
import ReferenceProvider from 'providers/Reference';
import RouterProvider from 'providers/Router';
import TrackingProvider from 'providers/Tracking';
import { memo } from 'react';

import { useBrowserHistoryListener } from '../../helper/js/hooks/router';

function FlyerProjectPage() {
  useBrowserHistoryListener();

  return (
    <>
      <CookieConsentContainer />
      <KameleoonProvider />
      <ReferenceProvider>
        <RouterProvider>
          <TrackingProvider>
            <GlobalTrackingContainer />
            <ContentContainer>
              {({ hasError, loading }) => (
                <LanguageProvider>
                  <DocumentHead>
                    <BrowserContainer>
                      {loading ? (
                        <Loading />
                      ) : (
                        <AnimationProvider>
                          <main className="main">
                            <PageTitle />
                            <HeaderContainer hasError={hasError} />
                            <Subheader />
                            {hasError && <ErrorContainer />}
                            {!hasError && <ViewContainer />}
                            <FooterContainer hasError={hasError} />
                          </main>
                        </AnimationProvider>
                      )}
                      <SidebarContainer />
                    </BrowserContainer>
                  </DocumentHead>
                </LanguageProvider>
              )}
            </ContentContainer>
          </TrackingProvider>
        </RouterProvider>
      </ReferenceProvider>
      <ToggleBox />
    </>
  );
}

export default memo(FlyerProjectPage, () => true);
